import { useTranslation } from "react-i18next"

import type { NavigationBreadcrumbProps } from "../types"

import { Button } from "@/components/ui/button"

export function NavigationBreadcrumb({
  breadcrumb,
  canNavigateBack,
  onNavigateBack,
}: NavigationBreadcrumbProps) {
  const { t } = useTranslation()

  if (!canNavigateBack) return null

  return (
    <div className="flex flex-shrink-0 items-center gap-2">
      <Button size="sm" variant="outline" onClick={onNavigateBack}>
        ← {t("filepicker.back", { defaultValue: "Back" })}
      </Button>
      <div className="text-muted-foreground text-xs">{breadcrumb}</div>
    </div>
  )
}
